import React, { useState } from "react";
import "./Features.css";
import { useApp } from "../../AppContext/AppContext";

const Features = () => {
  const { currentColor } = useApp();
  const [expandedFeatures, setExpandedFeatures] = useState({
    compatibility: false,
    installation: false,
    quality: false,
    websites: false
  });

  const toggleFeature = (feature) => {
    setExpandedFeatures(prev => ({
      ...prev,
      [feature]: !prev[feature]
    }));
  };

  return (
    <section className="features">
      <h2 className="features__title">
        Features of <span style={{ color: currentColor }}>Video Downloader</span>
      </h2>

      <p className="features__subtitle">
        Effortless All Video Download at Your Fingertips
      </p>

      <div className="features__grid">
        <div className="feature">
          <div className="feature__content">
            <h3 className="feature__title">Full Compatibility</h3>
            <p className="feature__description">
            This video downloader offers a seamless, efficient, and direct way to download videos from virtually any website on both PC and Mac. 
              {expandedFeatures.compatibility && (
                <span className="expanded-text">
                  &nbsp;It is fully compatible with popular web browsers, including Chrome, Firefox, Safari, Edge, and others, ensuring a fast, reliable, and user-friendly experience. Whether you're saving high-quality videos for offline viewing or archiving your favorite content, this tool provides unmatched convenience and flexibility.
                </span>
              )}
            </p>
            <button 
              className="feature__button"
              onClick={() => toggleFeature('compatibility')}
            >
              {expandedFeatures.compatibility ? 'Show less' : 'Learn more'}
            </button>
          </div>

          <div className="feature__image-container">
            <img
              src="/assets/features1.svg"
              alt=""
              className="feature__image"
            />
            {/* <div className="feature__platforms">
              <div className="platform">
                <img src="/assets/features12.svg" alt="" />
                <span>Windows</span>
              </div>
              <div className="platform">
                <img src="/assets/features13.svg" alt="" />
                <span>Mac</span>
              </div>
            </div> */}
          </div>
        </div>

        <div className="feature feature--reverse">
          <div className="feature__content">
            <h3 className="feature__title">Free and No Installation</h3>
            <p className="feature__description">
              Without the need to install any APK or executable files on your
              computer, you can effortlessly save your favorite videos or audio.
             
              {expandedFeatures.installation && (
                <span className="expanded-text">
                  &nbsp; Simply visit the website, copy the URL of the content you wish to
                  download, and paste it into the provided field.
                </span>
              )}
            </p>
            <button 
              className="feature__button"
              onClick={() => toggleFeature('installation')}
            >
              {expandedFeatures.installation ? 'Show less' : 'Learn more'}
            </button>
          </div>

          <div className="feature__image-container">
            <img
                  src="/assets/features2.svg"
              alt=""
              className="feature__image"
            />
          </div>
        </div>

        <div className="feature">
          <div className="feature__content">
            <h3 className="feature__title">Download High-quality File</h3>
            <p className="feature__description">
            With Video Downloader, you don't have to worry about losing resolution when downloading videos.
              {expandedFeatures.quality && (
                <span className="expanded-text">
                  &nbsp;Additionally, it supports multiple formats, allowing you to download videos in MP4, MKV, AVI, and more, making it versatile for different devices and media players.
                </span>
              )}
            </p>
            <button 
              className="feature__button"
              onClick={() => toggleFeature('quality')}
            >
              {expandedFeatures.quality ? 'Show less' : 'Learn more'}
            </button>
          </div>

          <div className="feature__image-container">
            <img
               src="/assets/features3.svg"
              alt=""
              className="feature__image"
            />
          </div>
        </div>

        <div className="feature feature--reverse">
          <div className="feature__content">
            <h3 className="feature__title">Get Videos from Various Websites</h3>
            <p className="feature__description">
              Download videos from platforms like Facebook, Instagram, X
              (Twitter), Dailymotion, TikTok, LinkedIn, and more, in either MP4
              or MP3 format—it's that simple. 
              {expandedFeatures.websites && (
                <span className="expanded-text">
                  &nbsp;This Video Downloader supports a
                  wide range of websites.
                </span>
              )}
            </p>
            <button 
              className="feature__button"
              onClick={() => toggleFeature('websites')}
            >
              {expandedFeatures.websites ? 'Show less' : 'Learn more'}
            </button>
          </div>

          <div className="feature__image-container">
            <img
                    src="/assets/features4.svg"
              alt=""
              className="feature__image"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;
